import { Location, NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'ui-card',
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
  standalone: true,
  imports: [NgClass],
})
export class UICard {
  @Input() title?: string;
  @Input() description?: string;
  @Input() noBorder?: boolean;

  constructor(
    private location: Location,
    private router: Router,
    private aRoute: ActivatedRoute
  ) {}
}
